export default __webpack_public_path__ + "static/sketch_coverage-d2b2177ab376049b0ce30236071979c7.png";